export default {
  "nearby": "Near me",
  "alerts": "Alerts",
  "explore": "Explore",
  "cart": "Cart",
  "account": "Account",
  "services": "Services",
  "foodQuestion": "What would you like to order?",
  "foodSearch": "Search stores, dishes and products",
  "nearYou": "NEAR YOU",
  "chooseLocation": "Choose your location",
  "chooseLocationHelp": "We need it to show stores delivering to your area.",
  "chooseAddress": "Choose address",
  "changeZone": "Change area",
  "searchingStores": "Finding stores…",
  "storesAvailable": "stores available",
  "noStores": "No restaurants are available in your area.",
  "newStores": "New businesses",
  "justArrived": "JUST ARRIVED",
  "newLabel": "New",
  "recommendedLabel": "Recommended",
  "popularLabel": "Popular",
  "recommendedEyebrow": "STORE FAVORITES",
  "recommendedProducts": "Recommended",
  "addProduct": "Add",
  "openNow": "Open",
  "closedNow": "Closed",
  "exploreTitle": "Search for what you need",
  "exploreHelp": "Find businesses, dishes and products available in your area.",
  "searchThreeChars": "Enter at least 3 letters to search.",
  "searching": "Searching…",
  "noSearchResults": "No results found.",
  "businesses": "Businesses",
  "viewMenu": "View menu",
  "servicesTitle": "Services for you",
  "servicesHelp": "Choose an available service without leaving the app.",
  "loadingServices": "Loading services…",
  "enterService": "Request service",
  "anotherAddress": "Try selecting another address.",
  "loadingMenu": "Loading menu…",
  "backStores": "Back to stores",
  "searchMenu": "Search this menu",
  "noProducts": "No products found",
  "anotherWord": "Try another search.",
  "minimumOrder": "Minimum order",
  "products": "Products",
  "viewCart": "View cart",
  "yourOrder": "YOUR ORDER",
  "emptyCart": "Your cart is empty",
  "emptyCartHelp": "Add products from a store to start your order.",
  "browseStores": "Browse stores",
  "subtotal": "Subtotal",
  "deliveryCheckout": "Delivery will be calculated from your address at checkout.",
  "checkoutContinue": "Continue to checkout",
  "confirmOrder": "Confirm order",
  "backCart": "Back to cart",
  "deliverAt": "DELIVER TO",
  "change": "Change",
  "reference": "Number, floor or reference",
  "orderNote": "Note for the store",
  "payment": "Payment method",
  "cash": "Cash on delivery",
  "selected": "Selected",
  "estimatedDelivery": "Estimated delivery",
  "total": "Total",
  "loginFinish": "Sign in to complete your order",
  "loginContinue": "Sign in and continue",
  "tracking": "TRACKING",
  "myOrders": "My orders",
  "loginOrders": "Sign in to see your orders",
  "noOrders": "You have no orders yet",
  "profile": "PROFILE",
  "myAccount": "My account",
  "login": "Sign in",
  "register": "Create account",
  "name": "Name",
  "phone": "WhatsApp / phone",
  "email": "Email",
  "password": "Password",
  "enter": "Sign in",
  "registerMe": "Create account",
  "language": "Language",
  "languageHelp": "Applies to every new section",
  "notifications": "Notifications",
  "notificationsHelp": "Orders, promotions and news",
  "notificationsEnabled": "Enabled on this device",
  "notificationsBlocked": "Blocked in the browser",
  "notificationsBlockedHelp": "Permission was blocked. Open the padlock or site settings and allow notifications.",
  "notificationsUnsupported": "This browser does not support notifications",
  "notificationsError": "Permission could not be requested. Please try again.",
  "activate": "Enable",
  "review": "Review permission",
  "logout": "Sign out",
  "history": "History and tracking",
  "whereDeliver": "Where should we deliver?",
  "sharedAddress": "This address is shared with restaurants, delivery and future services.",
  "currentLocation": "Use my current location",
  "locating": "Finding your location…",
  "popularPlaces": "POPULAR PLACES",
  "selectAddress": "Choose your address",
  "allInOne": "EVERYTHING IN ONE PLACE",
  "exploreHuaraz": "Explore Huaraz",
  "portalSub": "Food, delivery and new services near you.",
  "restaurants": "Restaurants",
  "taxiLabel": "Taxi",
  "supermarket": "Supermarket",
  "orderFood": "Order food and products",
  "soon": "Coming soon",
  "available": "Available",
  "navBusinesses": "Businesses",
  "navJoin": "Join us",
  "heroTitle": "All of Huaraz, delivered to your door",
  "heroDescription": "Discover restaurants, cravings and local businesses. Order in a few steps and receive it wherever you are.",
  "choose": "Choose",
  "favoriteBusiness": "your favorite business",
  "order": "Order",
  "easySecure": "quickly and securely",
  "receive": "Receive",
  "atYourLocation": "at your location",
  "exploreFromPc": "Explore from my PC",
  "localBusinesses": "Local businesses",
  "deliveryInHuaraz": "Delivery in Huaraz",
  "orderTracking": "Order tracking",
  "liveApp": "Live app",
  "shopHere": "You can order right here",
  "shipments": "Delivery",
  "openApp": "Open the app",
  "dailyServices": "Services for your everyday needs",
  "dailyServicesDescription": "Shop, send and discover local options from one platform.",
  "restaurantServiceDescription": "Order food and products from the best local businesses.",
  "exploreBusinesses": "Explore businesses",
  "pickupDelivery": "Pickup and delivery",
  "pickupDescription": "We carry your package from point A to point B.",
  "requestDelivery": "Request a delivery",
  "taxiDescription": "Request a fast and safe ride.",
  "temporarilyUnavailable": "Temporarily unavailable",
  "requestTaxi": "Request a taxi",
  "verySoon": "Coming soon",
  "buyLocal": "SHOP LOCAL",
  "meetBusinesses": "Meet our businesses",
  "previousBusinesses": "Previous businesses",
  "nextBusinesses": "Next businesses",
  "growTogether": "WE GROW WITH YOU",
  "joinDelivery": "Join Delivery Huaraz",
  "joinDescription": "Tools to sell, deliver and manage your operation from a platform built for Huaraz.",
  "forBusinesses": "FOR BUSINESSES",
  "growSales": "Grow your sales",
  "growSalesDescription": "Receive orders, manage your menu and reach more customers without losing control of your operation.",
  "registerBusiness": "Register my business",
  "forDrivers": "FOR DRIVERS",
  "earnDelivering": "Earn money delivering",
  "driverDescription": "Receive orders, deliveries and alerts from an integrated tool designed for working on the move.",
  "applyDriver": "Apply as a driver",
  "footerDescription": "Food, delivery and local services in one place.",
  "enterApp": "Enter the app",
  "closeApp": "Close app",
  "gpsPrompt": "Enabling GPS ensures an accurate address and a smooth delivery.",
  "shopping": "Shopping",
  "events": "Events",
  "mobileJoinDescription": "Businesses and drivers have their own tools, alerts and work panels.",
  "haveBusiness": "Do you own a business?",
  "mobileBusinessDescription": "Receive orders, manage your menu and reach more customers in Huaraz.",
  "haveMotorcycle": "Do you have a motorcycle?",
  "mobileDriverDescription": "Earn money with orders, deliveries and new services from the integrated panel.",
  "myAddresses": "My addresses",
  "addressHelp": "Home, work, hotel and more",
  "walletCredits": "Wallet and credits",
  "walletHelp": "Balances, top-ups and benefits",
  "myFavorites": "My favorites",
  "favoriteHelp": "Stores you saved",
  "myCart": "My cart",
  "cartHelp": "Continue shopping",
  "helpInfo": "Help and information",
  "helpInfoDesc": "Questions, policies and terms",
  "forgotPassword": "I forgot my password",
  "favoriteTitle": "Favorite stores",
  "favoriteLogin": "Sign in to save your favorites",
  "noFavoritesZone": "You have no favorite stores in your area",
  "favoriteEmptyHelp": "Save the stores you like from their menu.",
  "reviews": "REVIEWS",
  "backMenu": "Back to menu",
  "noReviews": "There are no reviews yet.",
  "infoTitle": "Help and information",
  "recoverAccess": "RECOVER ACCESS",
  "newPassword": "New password",
  "recoverHelp": "You will receive a code at the email registered with Delivery Huaraz.",
  "sendCode": "Send code",
  "verifyCode": "Verify code",
  "savePassword": "Save password",
  "cartProductsTitle": "Products in your cart",
  "clearCart": "Clear",
  "decreaseQuantity": "Reduce quantity or remove product",
  "increaseQuantity": "Increase quantity",
  "cartCommentPlaceholder": "Add a comment or instructions for the business…",
  "coupon": "Coupon",
  "applyCoupon": "Apply",
  "couponInvalid": "This coupon is not valid.",
  "discountApplied": "Discount applied",
  "paymentDetails": "Payment details",
  "deliveryFee": "Delivery fee",
  "businessCharge": "Business charge",
  "discount": "Discount",
  "totalToPay": "Total to pay",
  "confirmDeliveryAddress": "CONFIRM YOUR DELIVERY ADDRESS",
  "selectAnAddress": "Choose an address",
  "verifyCurrentAddress": "Make sure your order is delivered to your current location.",
  "addressConfirmed": "Address confirmed",
  "correctAddress": "Yes, this is the correct address",
  "confirmAddressHelp": "You must confirm it before continuing to payment",
  "continuePayment": "Continue to payment",
  "fulfillmentQuestion": "How would you like to receive your order?",
  "deliveryOption": "Delivery",
  "deliveryOptionHelp": "We deliver it to your address",
  "pickupOption": "Store pickup",
  "pickupOptionHelp": "Pick it up when it is ready",
  "pickupAtStore": "Pickup at the store",
  "pickupAddressHelp": "Check the store address",
  "pickupReadyHelp": "The store will notify you when your order is ready.",
  "noCost": "No charge",
  "noDeliveryFee": "No delivery fee",
  "howPayPickup": "How will you pay when you pick up your order?",
  "howPayDelivery": "How will you pay when your order arrives?",
  "paymentMethodForLocation": "Payment method available for your location",
  "payOnDeliveryLabel": "PAY ON DELIVERY",
  "payOnDeliveryTitle": "Cash, Yape or Plin",
  "payOnDeliveryHelp": "Choose how you will pay when your order arrives.",
  "choosePayment": "Choose",
  "choosePaymentOnDelivery": "Choose how you will pay on delivery",
  "confirmAddressTitle": "Confirm your address",
  "addressMapInstructions": "Use GPS, then move the marker exactly to the delivery entrance.",
  "savedAddressesTitle": "MY SAVED ADDRESSES",
  "genericAddress": "Address",
  "useGpsNow": "Use my GPS now",
  "gpsUnsupported": "This device cannot provide a GPS location.",
  "gpsPermissionRequired": "Location permission is required to use GPS.",
  "gpsUnavailableHelp": "We could not get an accurate location. Search for your street or move the marker.",
  "gpsAccuracy": "Approximate accuracy",
  "gpsMoveMarker": "Move the marker to correct it.",
  "gpsConfirmPoint": "Confirm the point on the map.",
  "addressSearchPlaceholder": "Search for a street, avenue, hotel or landmark",
  "search": "Search",
  "addressNotFoundHelp": "We could not find that address. Move the marker to your entrance.",
  "mapNotConfigured": "The map has not been configured yet.",
  "mapLoadFailed": "The map could not be loaded.",
  "dragMarkerHelp": "Drag the marker to your entrance",
  "addressHouseLabel": "Number, floor or landmark",
  "addressHousePlaceholder": "E.g. Blue house, door 2",
  "saveAs": "Save as",
  "homeTag": "Home",
  "workTag": "Work",
  "hotelTag": "Hotel",
  "otherTag": "Other",
  "saveInMyAddresses": "Save in My addresses",
  "savingAddress": "Saving…",
  "confirmThisAddress": "Confirm this address",
  "popularHuarazPlaces": "Known places in Huaraz",
  "noStoresAtPoint": "We could not find businesses for this point.",
  "gpsOutsideCoverageHelp": "GPS may have placed you outside the service area. Move the marker to your entrance.",
  "correctMapLocation": "Correct location on the map",
  "checkingCurrentLocation": "Checking your current location…",
  "checkAddressWithGps": "Check this address with my GPS",
  "locationVerifiedForOrder": "Location checked for this order.",
  "gpsMatchesDeliveryAddress": "Your current location matches the delivery address.",
  "youMayHaveMoved": "It looks like you are somewhere else",
  "currentLocationDistance": "Your current GPS location is about {distance} km from the selected address.",
  "useCurrentGpsAndAdjust": "Use my GPS and adjust",
  "deliverToSelectedAddress": "Deliver to the selected address",
  "gpsNeedsConfirmation": "GPS needs your confirmation",
  "gpsAccuracyTooLow": "Current accuracy is approximately {accuracy} m. Review the point before ordering.",
  "reviewLocationOnMap": "Review location on the map",
  "gpsCouldNotVerify": "We could not verify where you are",
  "addressVerificationExpired": "We need to check the delivery address again. We will take you back to the cart.",
  "back": "Back", "close": "Close", "home": "Home", "offers": "Offers",
  "loadingNavigation": "Loading navigation", "mainNavigation": "Main navigation",
  "customizeOrder": "Customize your order", "loadingProduct": "Loading product…",
  "chooseOptions": "Choose your options", "chooseOneOption": "Choose one option", "chooseUpTo": "Choose up to {count}",
  "optional": "Optional", "additional": "Extra", "additionals": "Extras",
  "continue": "Continue", "continueAndAdd": "Continue and add for",
  "exclusiveOffers": "EXCLUSIVE OFFERS", "yapePromos": "Yape Deals",
  "yapeSpecialPrices": "Special prices when paying with Yape.", "yapeLocationHelp": "To confirm which businesses deliver to you.",
  "searchPromoOrBusiness": "Search for a deal or business", "loadingPromotions": "Loading promotions…",
  "promotionsLoadError": "We could not load the promotions.", "noYapePromos": "There are no active Yape Deals yet.",
  "comeBackForOffers": "Come back soon for new offers.", "availablePromotions": "Available promotions",
  "yapeOnly": "Yape only", "viewMyOrder": "View my order", "benefitsForYou": "Benefits for you", "seeAll": "See all",
  "exclusiveDiscounts": "Exclusive discounts", "accordingToPromotions": "Subject to promotions",
  "deliveriesAndPickups": "Delivery and pickup", "accordingToCoverage": "Subject to coverage",
  "shoppingBenefits": "Shopping rewards", "moreNewsSoon": "More news soon",
  "category": "Category", "backToCategories": "Back to categories",
  "storesNearLocation": "Businesses available near your location.", "searchIn": "Search in",
  "categoryAddressHelp": "We need your address to show businesses in this category.", "inYourZone": "IN YOUR AREA",
  "loadingBusinesses": "Loading businesses", "businessesLoadError": "We could not load the businesses.",
  "noCategoryBusinesses": "There are no {category} businesses available in your area.",
  "discoverMenuPromotions": "Discover their menu and promotions.",
  "yapeExclusivePayment": "Exclusive promotion when paying with Yape", "yapePromoOrderNotice": "This order contains a Yape Deal.",
  "exclusivePaymentMethod": "EXCLUSIVE PAYMENT METHOD", "payWithYape": "Pay with Yape", "keepPromotionalPrice": "Required to keep the promotional price",
  "integrationPending": "Integration pending", "storeClosed": "The business is closed", "checkoutStoreClosedHelp": "You cannot confirm this order until the business is available again.",
  "selectOptionToContinue": "Select an option to continue.", "cash": "Cash", "cashChangeHelp": "Indicate if you need change", "coordinatedTransfer": "Coordinated transfer",
  "cashAmountPlaceholder": "How much will you pay with? Example: 50", "processing": "Processing…", "confirmCashOrder": "Confirm cash order",
  "confirmOrderWith": "Confirm order with {method}", "cashChangeInstructions": "If you need change, enter the banknote value. If paying the exact amount, leave it blank.",
  "transferPickupInstructions": "You will not be charged in the app. Confirm the {method} details with the business before transferring.",
  "transferDeliveryInstructions": "You will not be charged in the app. Confirm the {method} details with the business or courier before transferring.",
  "selectPaymentMethod": "Select a payment method", "storeActions": "Business actions", "searchProducts": "Search products", "shareStore": "Share business",
  "storeClosedMenuHelp": "Outside business hours. You can still browse the menu.", "closeNotice": "Close notice",
  "searchInStore": "Search in {store}", "storeCategories": "Business categories", "customizable": "Customizable", "added": "Added",
  "productDetail": "Product details", "customizeAndAdd": "Customize and add", "addToOrder": "Add to order", "addedToCart": "Added to cart",
  "storeNotAcceptingOrders": "This business is closed and is not accepting orders right now."
};
